module.exports = __webpack_public_path__ + "assets/img/90@3x.fbbe66b7.png";